/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Intelligence_TitleInputs */

const en_directory_launch_intelligence_title = /** @type {(inputs: Directory_Launch_Intelligence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month Intelligence`)
};

const zh_directory_launch_intelligence_title = /** @type {(inputs: Directory_Launch_Intelligence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月度洞察`)
};

/**
* | output |
* | --- |
* | "Month Intelligence" |
*
* @param {Directory_Launch_Intelligence_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_intelligence_title = /** @type {((inputs?: Directory_Launch_Intelligence_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Intelligence_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_intelligence_title(inputs)
	return zh_directory_launch_intelligence_title(inputs)
});
export { directory_launch_intelligence_title as "directory.launch.intelligence_title" }